// extracted by mini-css-extract-plugin
export default {"uploaded":"styles_uploaded__HXL6u","btn":"styles_btn__bjtDH","textUploaded":"styles_textUploaded__mRVCO"};